import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ApplicationEffects } from './application.effects';

@NgModule({
  declarations: [],
  imports: [EffectsModule.forFeature([ApplicationEffects])],
})
export class ApplicationModule {}
